import React from "react"
import { Link } from "gatsby"
import { TIMINGS, ANIMATION } from "../config/animation"

const CarouselSlide = (
  {
    title,
    subtitle,
    image,
    partner,
    backgroundImage,
    link,
    heroImage,
    copyright,
  },
  key
) => {
  return (
    <div className="col2" key={key}>
      <div
        className={`col-large ${heroImage && "col-hero"}`}
        data-sal={ANIMATION.effect}
        data-sal-delay={TIMINGS.fast}
        data-sal-easing={ANIMATION.ease}
        data-sal-duration={ANIMATION.duration}
      >
        <h1>
          <div dangerouslySetInnerHTML={{ __html: title }} />
          {copyright ? <sup>®</sup> : ""}
        </h1>
        <p>{subtitle}</p>
        {link ? (
          <Link className="mobile-hidden button" to={link}>
            Explore
          </Link>
        ) : (
          <hr />
        )}
      </div>
      <div
        className="carousel-image"
        data-sal={ANIMATION.effect}
        data-sal-delay={TIMINGS.medium}
        data-sal-easing={ANIMATION.ease}
        data-sal-duration={ANIMATION.duration}
      >
        {image ? <img src={image} alt=""></img> : ""}
        {partner ? (
          <img src={partner} className="carousel__partner" alt="" />
        ) : (
          ""
        )}

        {/* {heroImage ? (
          <img className="hero-image" src={image} alt=""></img>
        ) : (
          <img src={image} alt=""></img>
        )} */}

        {/* {link && <button>Explore</button>} */}
      </div>
      {backgroundImage && (
        <div
          className="hero-bg"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        />
      )}
    </div>
  )
}

export default CarouselSlide
